<template>
  <div
    v-show="Active"
    class="my-3"
    :QuestionNo="QuestionNo"
  >
    <div
      class="bg-white rounded border"
      :class="{'border-danger':MustError }"
    >
      <h6 class="text-break text-break-word m-3">
        <span
          v-show="isMust"
          class="text-break text-break-word text-danger ml-n2"
        >*</span>
        {{ title }}
      </h6>
      <div
        v-if="img"
        class="px-3"
      >
        <img
          :src="img"
          alt=""
          class="mw-100 h-auto rounded"
        >
      </div>
      <hr class="mx-3">
      <b-form-radio-group
        v-model="value"
        class="m-3 row"
      >
        <div
          v-for="(Item,index) in formDetailItem"
          :key="index"
          class="p-1"
          :class="[answersCol]"
          @blur="Check()"
          @click="value = index"
        >
          <div
            v-if="!Item.other"
            :class="[{
              'bg-customize':value==index ,
              'bg-success':value==index ,
              'text-white':value==index,
              'flex-column':value==index && !Item.optionImage ,
              'align-items-center': value==index && !Item.optionImage
            },'rounded py-1 px-2']"
          >
            <b-form-radio
              v-model="value"
              name="some-radios"
              :value="index"
              :seqno="Item.seqno"
              :style="{'color': value==index ? themeFontColor : ''}"
            >
              <div class="text-break text-break-word">
                {{ Item.detailItemName }}
              </div>
            </b-form-radio>
            <div
              v-if="!!Item.optionImage"
              class="w-50 py-1"
            >
              <img
                :src="Item.optionImage"
                alt=""
                class="mw-100 h-auto rounded"
              >
            </div>
          </div>
        </div>
        <div
          v-if="formDetailItem && formDetailItem[otherIndex] && formDetailItem[otherIndex].other"
          class="p-1 col-12"
          @blur="Check()"
          @click="value = otherIndex"
        >
          <div
            :class="[
              'rounded py-1 px-2 w-100',
              value === otherIndex ? 'bg-customize bg-success text-white flex-column align-items-center' : ''
            ]"
          >
            <b-form-radio
              v-model="value"
              name="some-radios"
              :value="otherIndex"
              :seqno="formDetailItem[otherIndex].seqno"
              :style="{'color': value==otherIndex ? themeFontColor : ''}"
            >
              <div class="text-break text-break-word">
                {{ formDetailItem[otherIndex].detailItemName }}
              </div>
            </b-form-radio>
            <img
              v-if="!!formDetailItem[otherIndex].optionImage"
              :src="formDetailItem[otherIndex].optionImage"
              alt=""
              class="mw-100 h-auto rounded"
            >
            <b-form-textarea
              v-if="value && formDetailItem[value] && formDetailItem[value].other"
              v-model="content"
              class="my-1 col-12"
              maxlength="1000"
            />
          </div>
        </div>
      </b-form-radio-group>
      <!-- </b-form-group> -->
    </div>
    <p
      v-show="ShowMustWording"
      class="text-danger font-size-md"
    >
      {{ othercheck ? mustOtherAlertWording:mustAlertWording }}
    </p>
  </div>
</template>

<script>
// import { updateLocale } from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    formDetailItem: Array,
    QuestionNo: Number,
    title: String,
    img: String,
    must: Boolean,
    mustAlertWording: String,
    mustOtherAlertWording: String,
    Active: Boolean
  },
  data() {
    return {
      value: -1,
      ShowMustWording: false,
      MustError: false,
      isMust: this.must,
      old_value: -1,
      content: '',
      othercheck: false
    };
  },
  methods: {
    Check() {
      const vm = this;
      if (vm.isMust && vm.value === -1) {
        vm.othercheck = false;
        vm.DisplayMustError();
        return false;
      }
      if (vm.value !== -1 && vm.formDetailItem[vm.value].other === true && vm.content === '') {
        vm.othercheck = true;
        vm.DisplayMustError();
        return false;
      }
      vm.HideMustError();
      return true;
    },
    DisplayMustError() {
      this.ShowMustWording = true;
      this.MustError = true;
    },
    HideMustError() {
      this.ShowMustWording = false;
      this.MustError = false;
    }
  },
  computed: {
    ...mapState('formSetting', ['themeFontColor']),
    answersCol() {
      const maxAnswersLength = this.formDetailItem.reduce((max, item) => Math.max(max, item?.detailItemName?.length ?? 0), 0);
      const haveImage = this.formDetailItem.some((item) => item.optionImage);

      if (haveImage || maxAnswersLength > 12) return 'col-12';

      if (maxAnswersLength > 6) return 'col-12 col-md-6';

      if (maxAnswersLength > 3) return 'col-6 col-md-4';

      return 'col-4 col-md-3';
    },
    otherIndex() {
      return this.formDetailItem.findIndex((item) => item.other);
    }
  },
  watch: {
    value() {
      const vm = this;
      if (vm.isMust && vm.value.length === -1) {
        this.othercheck = false;
        vm.DisplayMustError();
      } else {
        vm.HideMustError();
      }
      if (vm.formDetailItem[vm.value].other === true) {
        this.$emit('UpdateAnswer', this.QuestionNo, [this.value + 1], '', false);
      } else {
        vm.content = '';
        this.$emit('UpdateAnswer', this.QuestionNo, [this.value + 1], '', true);
      }
    },
    content() {
      const vm = this;
      if (vm.content !== '') {
        this.HideMustError();
      }
      if (vm.formDetailItem[vm.value].other === true && vm.content === '') {
        vm.$emit('UpdateAnswer', vm.QuestionNo, [vm.value + 1], '', false);
      } else if (vm.formDetailItem[vm.value].other === true && vm.content !== '') {
        vm.$emit('UpdateAnswer', vm.QuestionNo, [vm.value + 1], vm.content, true);
      }
    }
  }
};
</script>
